/**
 * Instructions for the first session after a handoff: where the conversation
 * moved and what it was working on. The conversation itself is not repeated
 * here: a resumed agent session keeps its own history, and a fresh one is
 * rebuilt from the canonical Crowdex transcript by the agent runtime.
 */
export function conversationHandoffContext(input: {
  messages: readonly { role: string; parts: unknown }[];
  sourceAgent: string;
  targetAgent: string;
  repository?: string | null;
  branch?: string | null;
  direction?: 'agent' | 'local-to-cloud' | 'cloud-to-local' | 'worktree-to-local';
  /** The agent's own session moved with the conversation and resumes as it was. */
  agentSessionMoved?: boolean;
}): string {
  const location =
    input.direction === 'local-to-cloud'
      ? 'The workspace moved from the local machine to Crowdex Cloud.'
      : input.direction === 'cloud-to-local'
        ? 'The durable cloud checkpoint was applied directly to the local workspace without pushing it.'
        : input.direction === 'worktree-to-local'
          ? 'The conversation moved from a linked Git worktree to the primary local checkout.'
          : 'The agent runtime changed while the Crowdex conversation stayed open.';
  return [
    input.agentSessionMoved === true
      ? 'You are continuing your own session of this Crowdex conversation on a new host.'
      : 'You are continuing an existing Crowdex conversation in a new agent session.',
    `Previous agent: ${input.sourceAgent}`,
    `Current agent: ${input.targetAgent}`,
    location,
    ...(input.repository ? [`Repository: ${input.repository}`] : []),
    ...(input.branch ? [`Branch: ${input.branch}`] : []),
    'Continue from the newest user request without repeating completed work.',
  ].join('\n');
}
